// import packages
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Link, useParams } from "react-router-dom";

//Import assets
import "./partners.scss"

//Import Components
import PageWrapper from '../../components/pageContentViews/pageWrapper'
import { Tabs } from "antd";
import { LinkButton } from "../../components/buttons/buttons";
import PartnersList from "./partners/Partners"
import PartnerCategories from "./categories/PartnerCategories"
import PartnerOffers from "./offers/PartnerOffers"

// Import utils
import { mapStateToProps } from "../../redux/mapStateToProps";
import { history } from "../../configs/history";


const Partners = () => {
    const { pageName } = useParams()
    useEffect(() => {
        if (!pageName) {
            history.push('/partners/items')
        }
    }, [pageName])
    let data = [
        {
            id: "1",
            title: 'Գործընկերներ',
            slug: 'items',
            link: '/partners/items/add',
            page: <PartnersList/>,
        },
        {
            id: "2",
            title: 'Կատեգորիաներ',
            slug: 'categories',
            link: '/partners/categories/add',
            page: <PartnerCategories/>,
        },
        {
            id: "3",
            title: 'Առաջարկներ',
            slug: 'offers',
            link: '/partners/offers/add',
            page: <PartnerOffers/>,
        },
    ]

    return <PageWrapper hideBreadcrumbs={true}>
        <section className={'partners'}>
            <div className={'add-wrapper'}>
                <LinkButton title={'Ավելացնել'}
                            link={data?.find(item=>item.slug===pageName)?.link}
                            className={"header-btn"}/>
            </div>
            <div className={`aside-menu-list`}>
                <Tabs
                    type="card"
                    activeKey={pageName || data[0]?.slug}
                    items={data.map(item => {
                        return {
                            label: <Link to={`/partners/${item?.slug}`} activeClassName='active'>
                                <span>{item?.title}</span>
                            </Link>,
                            key: item?.slug,
                            children: item?.page,
                        };
                    })}
                />
            </div>
        </section>
    </PageWrapper>
}
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(Partners);
